import React, { useEffect, useState } from "react";
import { observer, inject } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Button, Input, Select, Text, TextArea } from "../UI";
import userImg from "../asserts/img/fi-rs-user.svg";
import orderImg from "../asserts/img/taskType.svg";
import CallsImg from "../asserts/img/fi-rs-file-invitation.svg";
import TasksImg from "../asserts/img/task_list.svg";
import orderLineImg from "../asserts/img/order_list.svg";
import hoursImg from "../asserts/img/hours.svg";
import { useNavigate } from "react-router-dom";
import { useTheme } from "styled-components";
import { DatePicker, LocalizationProvider } from "@material-ui/pickers";
import DateFnsUtils from "@material-ui/pickers/adapter/date-fns";
import { he } from "date-fns/locale";
import { inputsHasError, useInput } from "../utils/hooks";
import { isNotEmpty, minLength, withError } from "../validation";
import { subMonths } from "date-fns";
import { useSearchParams } from "react-router-dom";
import calenderImg from "../asserts/img/calender_input.svg";
import PageHeader from "../layouts/PageHeader";
import { ClipLoader } from "react-spinners";
import Checkbox from "../UI/Checkbox/Checkbox";
import descriptionImg from "../asserts/img/q.svg";
import ErrorNotification from "../components/ErrorNotification";

const ReportDetailMobile = ({ userStore, reportDetailsStore }) => {
  const { t } = useTranslation("report_details");
  const theme = useTheme();
  const [isLoading, setLoading] = useState(false);
  const [isSaving, setSaving] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [orders, setOrders] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [calls, setCalls] = useState([]);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [selectedReport, setSelectedReport] = useState(null);
  const [report, setReport] = useState({});
  const [customer, setCustomer] = useState(
    selectedReport?.data?.CUSTNAME
      ? {
          value: selectedReport?.data?.CUSTNAME,
          label: selectedReport?.data?.CUSTDES,
        }
      : null
  );
  const [order, setOrder] = useState(
    !!selectedReport?.data?.ORDNAME
      ? {
          value: selectedReport?.data?.ORDNAME,
          label: selectedReport?.data?.DETAILS,
        }
      : null
  );
  const [task, setTask] = useState(
    selectedReport?.data?.ZCOR_TASKNAME
      ? {
          value: selectedReport?.data?.ZCOR_TASKNAME,
          label:
            selectedReport?.data?.ZCOR_TASKDES +
            " " +
            selectedReport?.data?.ZCOR_TASKNAME,
        }
      : null
  );
  const [call, setCall] = useState(
    selectedReport?.data?.ZCOR_DOCNO
      ? {
          value: selectedReport?.data?.ZCOR_DOCNO,
          label: selectedReport?.data?.ZCOR_DOCNO,
        }
      : null
  );
  const [orderslines, setOrderLines] = useState([]);
  const [orderline, setOrderLine] = useState(
    selectedReport?.data?.OLINE
      ? {
          value: selectedReport?.data?.OLINE,
          label: selectedReport?.data?.PARTDES,
        }
      : null
  );

  const [selectedDate, setSelectedDate] = useState(
    selectedReport?.data?.CURDATE
  );
  const [error, setError] = useState("");
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [showErrorNotification, setShowErrorNotification] = useState({
    show: false,
    text: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      reportDetailsStore.setError("");
      userStore.setError("");
      const repParam = searchParams.get("itemId");

      const customersArray = userStore.customers || [];
      const customers = customersArray.map((cust) => ({
        value: cust.CUSTNAME,
        label: cust.CUSTDES,
      }));

      if (!userStore.isError) {
        setCustomers(customers);
      }

      if (!repParam) return;

      const selectedReport = await reportDetailsStore.getReport({
        DETAIL: repParam,
        ZCR_USERID: userStore.userDetails.ZCR_USERID,
      });

      if (!!reportDetailsStore.error) {
        setError(reportDetailsStore.error);
      }

      if (selectedReport) {
        setSelectedReport(...selectedReport);
      } else {
        setError(t("no_report_found"));
      }

      setLoading(false);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      userStore.setError("");
      const ordersArray = await userStore.getCustomerOrders({
        CUSTNAME: customer?.value,
      });

      await reportDetailsStore.getTasksByCustomer({
        CUSTNAME: customer?.value,
        DATE: subMonths(new Date(), 1),
      });

      await reportDetailsStore.getCallsByCustomer({
        CUSTNAME: customer?.value,
        DATE: subMonths(new Date(), 1),
      });

      const tasksArray = reportDetailsStore.customerTasks || [];
      const callsArray = reportDetailsStore.customerCalls || [];

      const orders = ordersArray
        .map((ord) => ({
          value: ord.ORDNAME,
          label: ord.DETAILS,
          ORDERITEMS_SUBFORM: ord.ORDERITEMS_SUBFORM,
        }))
        .filter((ord) => ord.ORDERITEMS_SUBFORM.length > 0);

      const tasks = tasksArray.map((item) => ({
        value: item,
        label: item.TASKNAME + " " + item.TASKDES,
      }));

      const calls = callsArray.map((item) => ({
        value: item.DOCNO,
        label: item.DOCNO + " " + item.DETAILS,
      }));

      if (!reportDetailsStore.isError) {
        setTasks(tasks);
        setCalls(calls);
      }

      if (!userStore.isError) {
        setOrders(orders);
      }

      setLoading(false);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer]);

  useEffect(() => {
    const selectedOrder = orders.find((ord) => ord.value === order?.value);
    const orderlinesArray = selectedOrder?.ORDERITEMS_SUBFORM || [];
    const orderlines = orderlinesArray.map((line) => ({
      value: line.LINE,
      label: line.PDES,
    }));
    setOrderLines(orderlines);
  }, [order, orders]);

  useEffect(() => {
    setReport({
      CURDATE: selectedReport?.CURDATE || new Date(),
      USERID: userStore.userDetails?.ZCR_USERID,
      CUSTNAME: selectedReport?.CUSTNAME,
      PARTDES: selectedReport?.PARTDES,
      HOURS: selectedReport?.HOURS || 0,
      ORDNAME: selectedReport?.ORDNAME,
      OLINE: selectedReport?.OLINE,
      JOBDESC: selectedReport?.JOBDESC,
      ZCOR_TASKNAME: selectedReport?.TASKNAME,
      ZCOR_TASKDES: selectedReport?.TASKDES,
      ZCOR_DOCNO: selectedReport?.DOCNO,
      FREEOFCHARGE: selectedReport?.FREEOFCHARGE,
    });

    setCustomer(
      selectedReport?.CUSTNAME
        ? {
            value: selectedReport?.CUSTNAME,
            label: selectedReport?.CUSTDES,
          }
        : null
    );

    setOrder(
      !!selectedReport?.ORDNAME
        ? {
            value: selectedReport?.ORDNAME,
            label: selectedReport?.DETAILS,
          }
        : null
    );

    setTask(
      selectedReport?.ZCOR_TASKNAME
        ? {
            value: selectedReport?.ZCOR_TASKNAME,
            label:
              selectedReport?.ZCOR_TASKDES +
              " " +
              selectedReport?.ZCOR_TASKNAME,
          }
        : null
    );

    setCall(
      selectedReport?.ZCOR_DOCNO
        ? {
            value: selectedReport?.ZCOR_DOCNO,
            label: selectedReport?.ZCOR_DOCNO,
          }
        : null
    );

    setOrderLine(
      selectedReport?.OLINE
        ? {
            value: selectedReport?.OLINE,
            label: selectedReport?.PARTDES,
          }
        : null
    );

    setSelectedDate(selectedReport?.CURDATE);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedReport]);

  useEffect(() => {
    if (!!error) {
      setShowErrorNotification({
        show: true,
        text: error,
      });
    } else {
      setShowErrorNotification({
        show: false,
        text: "",
      });
    }
  }, [error]);

  const isNone = (e) => {
    if (Object.values(placeholders).includes(e)) return false;
    return true;
  };

  const isNotEmptyWithError = withError(
    isNotEmpty,
    t("error:text_field_empty_error")
  );

  const minLengthWithError = withError(
    (input) => minLength(input, 5),
    t("error:text_field_min_length_error", { count: 5 })
  );

  const isNoneWithError = () =>
    withError(isNone, t("error:text_field_empty_error"));

  const placeholders = {
    call: t("calls_list"),
    hours: t("hours"),
    description: t("description"),
    task: t("tasks_list"),
    order: t("choose_order"),
    orderline: t("choose_orderline"),
    customer: t("choose_customer"),
    date: t("choose_date"),
  };

  const isNumericNonZero = withError(
    (input) => !isNaN(parseFloat(input)) && isFinite(input) && input > 0,
    t("error:text_field_numeric_non_zero_error")
  );

  const descriptionInput = useInput({
    validation: [isNotEmptyWithError, minLengthWithError],
    placeholder: t("description"),
    value: report?.JOBDESC || "",
  });

  const hoursInput = useInput({
    validation: [
      isNotEmptyWithError,
      isNoneWithError("hours"),
      isNumericNonZero,
    ],
    type: "number",
    placeholder: t("hours"),
    value: report?.HOURS || "",
  });

  const tasksInput = useInput({
    validation: [isNotEmptyWithError, isNoneWithError("task")],
    value: task || placeholders["task"],
  });

  const callsInput = useInput({
    validation: [isNotEmptyWithError, isNoneWithError("call")],
    value: call || placeholders["call"],
  });

  const customerInput = useInput({
    validation: [isNotEmptyWithError, isNoneWithError("customer")],
    value: customer || placeholders["customer"],
  });

  const orderInput = useInput({
    validation: [isNotEmptyWithError, isNoneWithError("order")],
    value: order || placeholders["order"],
  });

  const orderlineInput = useInput({
    validation: [isNotEmptyWithError, isNoneWithError("orderline")],
    value: orderline || placeholders["orderline"],
  });

  const handleCustChange = (value) => {
    setCustomer(value);
    setOrder(null);
    setOrderLine(null);
    setTask(null);
    setCall(null);
    setReport({ ...report, CUSTNAME: value?.value });
  };

  const handleOrderChange = (value) => {
    setOrder(value);
    setOrderLine(null);
    setReport({ ...report, ORDNAME: value?.value });
  };

  const handleOrderLineChange = (value) => {
    setOrderLine(value);
    setReport({ ...report, OLINE: parseInt(value?.value) });
  };

  const handleDescriptionChange = (e) => {
    setReport({ ...report, JOBDESC: e.target.value });
  };

  const handleHoursChange = (e) => {
    setReport({ ...report, HOURS: e.target.value });
  };

  const handleTasksListChange = (value) => {
    setTask(value);

    const taskValue = value.value;
    if (!!taskValue?.OCUSTNAME) {
      setCustomer({ value: taskValue?.OCUSTNAME, label: taskValue.OCUSTDES });
    }
    if (!!taskValue?.ORDNAME) {
      setOrder({ value: taskValue.ORDNAME, label: taskValue.ORDPDES });
    }
    if (!!taskValue?.OLINE) {
      setOrderLine({ value: taskValue.OLINE, label: taskValue.PARTDES });
    }
    if (taskValue) {
      setReport({
        ...report,
        ZCOR_TASKNAME: value.value.TASKNAME,
        CUSTNAME: !!taskValue?.OCUSTNAME
          ? taskValue?.OCUSTNAME
          : report?.CUSTNAME,
        ORDNAME: !!taskValue?.ORDNAME ? taskValue?.ORDNAME : report?.ORDNAME,
        OLINE: !!taskValue?.OLINE ? taskValue?.OLINE : report?.OLINE,
      });
    }
  };

  const handleCallsListChange = (value) => {
    setCall(value);
    setReport({ ...report, ZCOR_DOCNO: value.value });
  };

  const handleDateChange = (date) => {
    var localDate = new Date(
      date.getTime() - date.getTimezoneOffset() * 60 * 1000
    );

    setReport({ ...report, CURDATE: localDate });
  };

  const handleDateClick = (event) => {
    setOpen((open) => !open);
    setAnchorEl(event.currentTarget);
  };

  const handelNewReportDetail = async () => {
    if (isSaving) return;

    reportDetailsStore.setError("");
    if (
      !inputsHasError(
        descriptionInput,
        customerInput,
        orderInput,
        orderlineInput,
        hoursInput
      )
    ) {
      const data = {
        ...report,
        HOURS: parseFloat(report.HOURS),
      };
      delete data.DETAILS;
      setSaving(true);

      selectedReport?.data !== undefined
        ? await reportDetailsStore.updateReport({
            REPORT: selectedReport?.REPORT,
            LINE: selectedReport?.LINE,
            data: data,
            FREEOFCHARGE: selectedReport?.FREEOFCHARGE === "Y" ? "N" : "Y",
          })
        : await reportDetailsStore.addReport(data);
      setSaving(false);

      if (reportDetailsStore.isError) {
        setError(reportDetailsStore.error);
      } else {
        navigate("/report_details");
      }
    }
  };

  const handelNoChargeChange = (isChecked) => {
    setReport({
      ...report,
      FREEOFCHARGE: isChecked ? "N" : "Y",
    });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
      }}>
      <PageHeader
        title={
          !!selectedReport
            ? t("report_detail_title")
            : t("report_detail_new_title")
        }
        back={() => navigate(-1)}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 24,
            padding: 20,
            overflow: "auto",
            height: "calc(100vh - 120px)",
          }}>
          {isLoading && (
            <div style={{ alignSelf: "center" }}>
              <ClipLoader color={theme.color.label} />
            </div>
          )}
          <LocalizationProvider dateAdapter={DateFnsUtils} locale={he}>
            <DatePicker
              closeOnSelect={true}
              mask="__/__/__"
              inputFormat="dd/MM/yy"
              value={selectedDate}
              onChange={(date) => {
                setSelectedDate(date);
                handleDateChange(date);
                setOpen(false);
              }}
              onClose={() => setOpen(false)}
              open={open}
              PopperProps={{
                placement: "bottom-end",
                anchorEl: anchorEl,
              }}
              renderInput={({ inputRef, inputProps }) => (
                <div
                  style={{
                    flexBasis: "100%",
                    width: "100%",
                  }}>
                  <Input
                    style={{
                      flexBasis: `100%`,
                    }}
                    {...inputProps}
                    inputFormat="dd/MM/yy"
                    validation={[isNotEmptyWithError, isNoneWithError("date")]}
                    ref={inputRef}
                    onChange={(e) => handleDateChange(e)}
                    onClick={handleDateClick}
                    endImg={calenderImg}
                  />
                </div>
              )}
            />
          </LocalizationProvider>
          <Select
            {...customerInput}
            style={{ textAlign: "start", flexBasis: `100%` }}
            startImg={userImg}
            options={customers || []}
            onChange={(value) => handleCustChange(value)}></Select>
          <Select
            {...orderInput}
            startImg={orderImg}
            style={{ textAlign: "start", flexBasis: `100%` }}
            options={orders || []}
            onChange={(value) => handleOrderChange(value)}></Select>
          <Select
            {...orderlineInput}
            startImg={orderLineImg}
            style={{ textAlign: "start", flexBasis: `100%` }}
            options={orderslines || []}
            onChange={(value) => handleOrderLineChange(value)}></Select>
          <Select
            style={{ textAlign: "start", flexBasis: `100%` }}
            {...tasksInput}
            creatable={true}
            startImg={TasksImg}
            options={tasks || []}
            onChange={(value) => handleTasksListChange(value)}></Select>
          <Select
            {...callsInput}
            creatable={true}
            style={{ textAlign: "start", flexBasis: `100%` }}
            startImg={CallsImg}
            options={calls || []}
            onChange={(value) => handleCallsListChange(value)}></Select>
          <TextArea
            {...descriptionInput}
            name="description"
            startImg={descriptionImg}
            placeholder={placeholders["description"]}
            rows={4}
            cols={90}
            onBlur={(e) => handleDescriptionChange(e)}
          />
          <Input
            style={{ textAlign: "start", flexBasis: `100%` }}
            {...hoursInput}
            startImg={hoursImg}
            onWheel={(e) => e.target.blur()}
            onBlur={(e) => handleHoursChange(e)}
          />
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              flexBasis: "50%",
              gap: 5,
              paddingInlineStart: 5,
            }}>
            <Text
              style={{
                fontSize: 13,
                fontWeight: 500,
                color: "#9FA2B4",
                textAlign: "start",
              }}>
              {t("NOCHARGEFLAG")}
            </Text>
            <Checkbox
              checked={report?.FREEOFCHARGE === "Y"}
              onChange={handelNoChargeChange}
              width={20}
              height={20}></Checkbox>
          </div>
        </div>
        {showErrorNotification.show && (
          <ErrorNotification
            text={showErrorNotification.text}
            onClose={() => setShowErrorNotification({ show: false })}
          />
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          borderTop: `1px solid #CBCED5`,
          justifyContent: "center",
          width: "100%",
          backgroundColor: "#FFFFFF",
          marginBottom: "auto",
          alignSelf: "end",
          padding: "12px 20px",
          gap: 14,
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
        }}>
        <Button buttonStyle="main" onClick={handelNewReportDetail}>
          {isSaving ? (
            <div style={{ paddingTop: 6 }}>
              <ClipLoader color={theme.color.white} size={22} />
            </div>
          ) : (
            t("common:send")
          )}
        </Button>
        <Button buttonStyle="border-linear" onClick={() => navigate(-1)}>
          {t("common:cancel")}
        </Button>
      </div>
    </div>
  );
};

export default inject(
  "userStore",
  "reportDetailsStore"
)(observer(ReportDetailMobile));
